// src/pages/Dashboard.jsx
import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import Navbar from "./Navbar.jsx";
import Header from "./fieldData/Header.jsx";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Tabs,
  Tab,
  Alert,
} from "@mui/material";
import Sidebar from "./Sidebar.jsx";
import EngineData from "./fieldData/EngineData.jsx";
import CompressorData from "./fieldData/CompressorData.jsx";
import Telemetry from "./fieldData/Telemetry.jsx";
import DeviceLocation from "./DeviceLocation.jsx";
import ChartManager from "./ChartManager.jsx";
import { CircularProgress } from "@mui/material";
import UnitSearch from "./UnitSearch/UnitSearch.jsx";
import SiteAdmin from "./SiteAdmin/SiteAdmin.jsx";
import axios from "../utils/axiosInstance";
import HomeView from "./HomeView/HomeView.jsx";
import Notifications from "./notifications/MainNotificationsComponent.jsx";
import AreaStatus from "./areaStatus/AreaStatus.jsx";
import UnitInformation from "./unitInformations/UnitInformation.jsx";
import UnitLocationFields from "./unitInformations/UnitLocationFields.jsx";
import NotificationGroup from "./unitInformations/NotificationGroup.jsx";
import CustomerGroup from "./unitInformations/CustomerGroup.jsx";
import Reports from "./reports/reports.jsx";
import CurrentAlarm from "./currentAlarm/currentAlarms.jsx";
import { MainPlungerPage } from "./plungerPage/mainPlungerPage.jsx";
import TimeRangeSelector from "./TimeRangeSelector.jsx";
import MainAlarm from "./deviceAlarm/mainAlarm.jsx";
import ErrorPage from "../pages/ErrorPage.js";
import DeleteRecipient from "./notifications/DeleteRecipient.jsx";
import NotificationHistory from "./deviceAlarm/NotificationHistory.jsx";
import PriorityVoice from "./deviceAlarm/PriorityVoice.jsx";
import SmsDelivery from "./deviceAlarm/SmsDelivery.jsx";
import ManageRecipient from "./deviceAlarm/ManageRecipients"; // or correct path
import { ControlPage } from "./control/controlPage.jsx";
import EventPartyDefaults from "./notifications/EventPartyDefaults.jsx";

import InvalidTable from "./InvalidTable/InvalidTable.jsx";
import HistoricalSPs from "./HistoicalSPs/HistoricalSPs.jsx";
import DataTable from "./DataTable/DataTable.jsx";
import RuntimeReport from "./RuntimeReport/RuntimeReport.js";
import MainAreaStatus from "./areaStatus/mainAreaStatus.jsx";
import ViewOnMap from "./groupHomeView/ViewOnMap.jsx";
import FaultSetpoints from "./FaultSetpoints/FaultSetpoints.jsx";
import FaultSnapshots from "./FaultSnapshots/FaultSnapshots.jsx";
import FanClutch from "./FanClutch/FanClutch.jsx";
export default function Dashboard({ setToken }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [timeRange, setTimeRange] = React.useState({
    type: "preset",
    hours: 168,
  });

  const [mobileOpen, setMobileOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [loadingEngineData, setLoadingEngineData] = React.useState(true);
  const [loadingSidebar, setLoadingSidebar] = React.useState(true);
  const [vendingMachineData, setVendingMachineData] = React.useState(null);
  const [data, setData] = React.useState(null);
  const [chartLoading, setChartLoading] = React.useState(false);
  const [chartData, setchartData] = React.useState(null);
  const [deviceLoading, setDeviceLoading] = React.useState(true);

  const allRegisters = [
    "COMP_OIL_PRES",
    "DISCHARGE_PRES",
    "DISCHARGE_TEMP_FINAL",
    "ENGINE_COOLANT_TEMP",
    "ENGINE_HOURMETER",
    "ENGINE_SPEED",
    "FIELD_PRES",
    "FLOW_METER",
    "INTERSTAGE_PRES",
    "SUCTION_PRES",
    "SYSTEM_VOTLS",
    "TAILSHAFT_TEMP",
    "STATE",
    "FLOW_RATE_SP",
    "ENGINE_OIL_TEMP",
    "ENGINE_OIL_PRES",
    "ENGINE_MANIFOLD_PRES",
    "DISCHARGE_2_TEMP",
    "COMP_HOURMETER",
    "AI10",
    "AI11",
    "AI12",
  ];

  const [user, setUser] = useState(null);
  const [loadedFromServer, setLoadedFromServer] = useState(false);
  const [selectedRegisters, setSelectedRegisters] = useState([...allRegisters]);

  useEffect(() => {
    const userString = localStorage.getItem("user");
    if (userString) {
      setUser(JSON.parse(userString));
    }
  }, []);

  // Get current tab from URL
  const getCurrentTab = () => {
    const path = location.pathname;
    // Check for nested routes first (more specific)
    if (path.includes("unit-search")) return "Unit Search";
    if (path.includes("site-admin")) return "Site Admin";
    if (path.includes("device/")) return null; // Device view active

    // Check for exact routes
    if (path.includes("home-view")) return "Home View";
    if (path.includes("current-alarms")) return "Current Alarms";
    if (path.includes("notifications")) return "Notifications";
    if (path.includes("area-status")) return "Area Status";
    if (path.includes("reports")) return "Reports";

    return; // Default fallback
  };

  useEffect(() => {
    setActiveTab(getCurrentTab());
  }, [location.pathname]);

  const [activeTab, setActiveTab] = useState(getCurrentTab());

  useEffect(() => {
    const pathParts = location.pathname.split("/");
    if (pathParts[2] === "device" && pathParts[3]) {
      const deviceId = pathParts[3];

      // Only set if we don't already have this device selected
      if (!selectedDevice || selectedDevice.id !== deviceId) {
        // Find device in vendingMachineData or create a basic device object
        if (vendingMachineData) {
          const device = vendingMachineData.find((d) => d.id === deviceId);
          if (device) {
            setSelectedDevice(device);
          } else {
            // Create basic device object if not found in sidebar data
            setSelectedDevice({
              id: deviceId,
              name: `Device ${deviceId}`,
            });
          }
        }
      }
    }
  }, [location.pathname, vendingMachineData, selectedDevice]);

  // Recursive function to get all device IDs
  const getDeviceIds = (nodes, level = 0) => {
    let ids = [];

    nodes.forEach((node, index) => {
      // If this node is a device, add its ID
      if (node.type === "device") {
        ids.push(node.id);
      }

      // If this node has children, recursively get IDs from children
      if (node.children && node.children.length > 0) {
        const childIds = getDeviceIds(node.children, level + 1);
        ids = ids.concat(childIds);
      }
    });

    return ids;
  };
  const [device, setDevice] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const fetchSidebarData = async () => {
    try {
      setLoadingSidebar(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API_GATEAWAY}/groups/sideBar`,
      );

      if (!response) throw new Error(`HTTP error! status: ${response.status}`);

      // filter only groups where name includes "prc" (case-insensitive)
      // const filtered = response.data.filter(item =>
      //   item.name?.toLowerCase().includes("prc")
      // );

      const filtered = response.data;
      const deviceIds = getDeviceIds(filtered);

      const postBody = {
        regList: ["SHUTDOWN_ENUM"],
        devices: deviceIds,
      };

      const postResponse = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/devices-status-types`,
        postBody,
      );

      // Create a map for quick lookup of device status and type
      const deviceStatusMap = {};
      postResponse.data.data.forEach((device) => {
        deviceStatusMap[device.id] = {
          deviceType: device.type,
          status: device.status,
        };
      });

      // Function to recursively update devices in the tree structure
      const updateDevicesWithStatus = (items) => {
        return items.map((item) => {
          if (item.type === "device") {
            if (deviceStatusMap[item.id]) {
              // Add status and deviceType to the device
              return {
                ...item,
                deviceType: deviceStatusMap[item.id].deviceType,
                status: deviceStatusMap[item.id].status,
              };
            }
          } else if (item.children && item.children.length > 0) {
            // Recursively update children
            return {
              ...item,
              children: updateDevicesWithStatus(item.children),
            };
          }
          return item;
        });
      };

      // Update the response data with status and type information
      const updatedData = await updateDevicesWithStatus(filtered);

      setVendingMachineData(updatedData);

      if (window.pyself) window.pyself.save("GeoGroups", updatedData);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingSidebar(false);
    }
  };

  useEffect(() => {
    fetchSidebarData();
  }, []);

  const fetchEngineData = React.useCallback(async (deviceId) => {
    // console.log("test" + deviceId);
    if (!deviceId) return;

    try {
      setLoadingEngineData(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/engine-data/${deviceId}`,
      );
      if (!response) throw new Error(`HTTP error! status: ${response.status}`);
      // const response2 = await axios.get(
      //   `${process.env.REACT_APP_API_GATEAWAY}/iot/getTags/${deviceId}`,
      // );
      // console.log("Fetched engine data from engine data api :", response.data);
      // console.log("Fetched engine data from engine tags api :", response2.data);
      setData(response.data);
    } catch (err) {
      console.error(err);
      setData(null);
    } finally {
      setLoadingEngineData(false);
    }
  }, []);

  useEffect(() => {
    if (selectedDevice?.id) {
      fetchEngineData(selectedDevice?.id);
    }
  }, [selectedDevice, fetchEngineData]);

  useEffect(() => {
    if (!user || !selectedDevice || !data) return; // wait for required data

    const fetchUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_GATEAWAY}/users/${user.id}`,
        );

        const serverUser = res.data;
        //console.log("user", serverUser);

        let reg = [];
        if (data.type === "C5E" || data.type === "C5") {
          const chartFields = serverUser.ChartFieldsC5;
          reg =
            typeof chartFields === "string"
              ? JSON.parse(chartFields)
              : chartFields || [];
        } else if (data.type === "WellPro II") {
          const chartFields = serverUser.ChartFieldsWELLPRO;
          reg =
            typeof chartFields === "string"
              ? JSON.parse(chartFields)
              : chartFields || [];
        }

        //console.log("Fetched user :", serverUser);

        if (Array.isArray(reg) && reg.length > 0) {
          setSelectedRegisters(reg);
        }
      } catch (err) {
        console.error("Error fetching user chart fields:", err);
      }
    };

    fetchUser();
  }, [user, selectedDevice, data]); // run effect whenever selectedDevice changes

  const fetchChartData = React.useCallback(
    async (deviceId) => {
      if (!deviceId || !timeRange || !data) return;

      try {
        setChartLoading(true);
        // Calculate timestamps locally
        let start, end;

        if (timeRange.type === "custom") {
          // Use custom timestamps
          start = timeRange.start;
          end = timeRange.end;
        } else {
          // Use preset hours
          end = Math.floor(Date.now() / 1000);
          start = end - timeRange.hours * 60 * 60;
        }

        // Update state for display purposes
        setStartTime(start);
        setEndTime(end);
        let body = [];
        const url = `${process.env.REACT_APP_API_GATEAWAY}/iot/chart-api/${deviceId}/${start}/${end}`;
        if (data.type == "C5E" || data.type == "C5") {
          body = [
            "COMP_HOURMETER",
            "DISCHARGE_2_TEMP",
            "DISCHARGE_TEMP_FINAL",
            "ENGINE_COOLANT_TEMP",
            "ENGINE_HOURMETER",
            "ENGINE_OIL_PRES",
            "ENGINE_MANIFOLD_PRES",
            "ENGINE_OIL_TEMP",
            "FLOW_RATE_SP",
            "TAILSHAFT_TEMP",
            "COMP_OIL_PRES",
            "DISCHARGE_PRES",
            "ENGINE_SPEED",
            "FIELD_PRES",
            "FLOW_METER",
            "INTERSTAGE_PRES",
            "SUCTION_PRES",
            "SYSTEM_VOTLS",
            "SPN1",
            "SPN2",
            "SPN3",
            "SPN4",
            "FMI1",
            "FMI2",
            "FMI3",
            "FMI4",
            "CM1",
            "CM2",
            "CM3",
            "CM4",
            "LAT",
            "LON",
            "AI10",
            "AI11",
            "AI12",
            "AI7",
            "AI8",
            "AI9",
          ];
        } else if (data.type == "WellPro II") {
          body = [
            "AI10",
            "AI11",
            "AI12",
            "COMP_OIL_PRES",
            "DISCHARGE_2_TEMP",
            "DISCHARGE_PRES",
            "DISCHARGE_TEMP_FINAL",
            "ENGINE_COOLANT_TEMP",
            "ENGINE_HOURMETER",
            "ENGINE_OIL_PRES",
            "ENGINE_MANIFOLD_PRES",
            "ENGINE_OIL_TEMP",
            "ENGINE_SPEED",
            "FIELD_PRES",
            "FLOW_METER",
            "FLOW_RATE_SP",
            "INTERSTAGE_PRES",
            "STATE",
            "SUCTION_PRES",
            "SYSTEM_VOTLS",
            "TAILSHAFT_TEMP",
            "SHUTDOWN_ENUM",
          ];
        }

        const response = await axios.post(url, body);

        const apiData = response.data?.data?.response;
        if (!apiData || !apiData.time)
          throw new Error("Invalid API response structure");

        setchartData(apiData);
      } catch (e) {
        console.error("❌ Failed to fetch chart data:", e);
        setchartData(null);
      } finally {
        setChartLoading(false);
      }
    },
    [timeRange, data, selectedDevice?.id],
  );

  // Clear chart data when device changes to ensure fresh data fetch
  useEffect(() => {
    if (selectedDevice?.id) {
      setchartData(null); // Clear existing chart data when device changes
    }
  }, [selectedDevice?.id]);

  // Fetch chart data when startime changes and we're on charts tab
  useEffect(() => {
    const currentPath = location.pathname.split("/").pop();
    if (currentPath === "charts" && selectedDevice?.id && data) {
      fetchChartData(selectedDevice.id);
    }
  }, [
    startTime,
    endTime,
    timeRange,
    selectedDevice?.id,
    location.pathname,
    fetchChartData,
  ]);

  // Reusable fetch function
  const fetchDevice = async () => {
    if (!selectedDevice?.id) return;

    try {
      setDeviceLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_GATEAWAY}/devices/details/${selectedDevice.id}`,
      );
      setDevice(response.data);
      setDeviceLoading(false);
      setSelectedDevice(response.data);
    } catch (err) {
      console.error("❌ Error fetching device:", err);
    }
  };

  // Automatically fetch when selectedDevice changes
  useEffect(() => {
    fetchDevice();
  }, [selectedDevice?.id]);

  // Manual refresh example
  const handleRefresh = () => {
    fetchDevice();
    refreshSidebar();
  };

  const handleDeviceSelect = (device) => {
    setSelectedDevice(device);
  };

  const handleDeviceNavigate = (device, page) => {
    setSelectedDevice(device);
    // Convert page names to URL-friendly format
    const pageMap = {
      "Engine Data": "engine-data",
      Charts: "charts",
      Alarms: "alarms",
      "Runtime Report": "runtime-report",
      "Unit Information": "unit-information",
    };
    const urlPage = pageMap[page] || "engine-data";
    navigate(`device/${device.id}/${urlPage}`);
  };

  const handleMainTabChange = (tab) => {
    const tabMap = {
      "Home View": "home-view",
      "Unit Search": "unit-search",
      "Site Admin": "site-admin",
      "Current Alarms": "current-alarms",
      Notifications: "notifications",
      "Area Status": "area-status",
      Reports: "reports",
    };

    // Clear selected device when navigating to main tabs
    setSelectedDevice(null);

    navigate(tabMap[tab] || "/");
  };

  useEffect(() => {
    const pathParts = location.pathname.split("/");
    // If not on a device route AND we have a selected device, clear it
    if (pathParts[2] !== "device") {
      setSelectedDevice(null);
    }
  }, [location.pathname]);

  const refreshSidebar = () => {
    fetchSidebarData();
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        overflowX: "auto",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: "100%",
          width: "100%",
          overflowX: "auto",
          overflowY: "auto",
        }}
      >
        <Sidebar
          loading={loadingSidebar}
          vendingMachineData={vendingMachineData}
          onDeviceSelect={handleDeviceSelect}
          selectedDevice={selectedDevice}
          onNavigate={handleDeviceNavigate}
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
          deviceIdToExpand={selectedDevice?.id}
        />
        <Box
          sx={{
            flex: 1,
            width: "100%",
            overflowX: "auto",
            height: "100%",
            overflowY: "auto",
          }}
        >
          {/* <Box className="bg-gradient-to-r from-red-600 to-red-600 animate-pulse" sx={{p:2}}>
            <Typography sx={{fontSize:"20px", fontWeight:"bold"}}>SMS Alerts Ending August 31, 2026. To continue receiving notifications, please download our new mobile app. <a href="https://play.google.com/store/apps/details?id=com.pytronix.MyWellAlertApp&pcampaignid=web_share" target="_blank"  style={{color:"#62b9ff"}}>[For Android]</a> <a href="https://apps.apple.com/tn/app/wellalert/id6758392078" style={{color:"#62b9ff"}} target="_blank">[For iOS]</a></Typography>
          </Box> */}
          <Navbar
            activeTab={activeTab}
            setActiveTab={handleMainTabChange}
            onMenuClick={() => setMobileOpen(!mobileOpen)}
            mobileOpen={mobileOpen}
            onLogout={async () => {
              try {
                await axios.post(
                  `${process.env.REACT_APP_API_GATEAWAY}/users/logout`,
                  {},
                  { withCredentials: true }, // so cookies are sent
                );
                localStorage.removeItem("token");
                localStorage.removeItem("user");
                sessionStorage.removeItem("previewGroupId");
                sessionStorage.removeItem("previewAppLogo");
              } catch (err) {
                console.error("Logout failed:", err);
              } finally {
                setToken(null);
                // navigate("/signin", { replace: true });
              }
            }}
          />

          <Routes>
            <Route path="/" element={<Navigate to="unit-search" replace />} />
            {/* ------------------- home-view Routes--------------------------- */}
            <Route
              path="home-view"
              element={<Navigate to="map-overview" replace />}
            />
            <Route path="home-view/map-overview" element={<HomeView />} />
            <Route path="home-view/alarm-history" element={<HomeView />} />
            <Route path="home-view/fleet" element={<HomeView />} />
            {/* ------------------- home-view Routes--------------------------- */}
            {/* ------------------- unit Search Routes--------------------------- */}
            <Route
              path="unit-search"
              element={<Navigate to="management" replace />}
            />
            <Route
              path="unit-search/management"
              element={<UnitSearch onUnitChange={refreshSidebar} />}
            />
            {/* ------------------- Search Routes--------------------------- */}
            {/* ------------------- site admin Routes--------------------------- */}
            <Route
              path="site-admin"
              element={<Navigate to="userList" replace />}
            />
            <Route path="/site-admin/userList" element={<SiteAdmin />} />
            <Route
              path="/site-admin/PUG"
              element={<SiteAdmin refreshSidebar={refreshSidebar} />}
            />
            <Route path="/site-admin/customer-group" element={<SiteAdmin />} />
            <Route path="/site-admin/application" element={<SiteAdmin />} />
            <Route path="/site-admin/audit" element={<SiteAdmin />} />
            {/* ------------------- site admin Routes--------------------------- */}
            <Route path="/current-alarms" element={<CurrentAlarm />} />
            {/* <Route path="/notifications" element={<Notifications />} /> */}

            <Route
              path="notifications"
              element={<Navigate to="notification-group" replace />}
            />
            <Route
              path="/notifications/notification-group"
              element={<Notifications />}
            />
            <Route
              path="/notifications/events-party"
              element={<Notifications />}
            />
            <Route
              path="/notifications/by-phone/:phoneNumber"
              element={<Notifications />}
            />
            <Route
              path="/notifications/by-email/:emailAddress"
              element={<Notifications />}
            />

            <Route path="/area-status" element={<MainAreaStatus />} />
            {/* ------------------- reports Routes--------------------------- */}
            <Route path="reports" element={<Navigate to="monthly" replace />} />
            <Route path="/reports/monthly" element={<Reports />} />
            <Route path="/reports/weekly" element={<Reports />} />
            <Route path="/reports/daily" element={<Reports />} />
            <Route path="/reports/report-group" element={<Reports />} />
            {/* ------------------- reports Routes--------------------------- */}
            <Route
              path="/device/:deviceId/*"
              element={
                <DeviceView
                  deviceLoading={deviceLoading}
                  device={device}
                  selectedDevice={selectedDevice}
                  handleRefresh={handleRefresh}
                  data={data}
                  fetchEngineData={fetchEngineData}
                  loadingEngineData={loadingEngineData}
                  chartData={chartData}
                  chartLoading={chartLoading}
                  fetchChartData={fetchChartData}
                  timeRange={timeRange} // Changed from startime
                  setTimeRange={setTimeRange}
                  refreshSidebar={refreshSidebar}
                  selectedRegisters={selectedRegisters}
                  setSelectedRegisters={setSelectedRegisters}
                />
              }
            />
            <Route path="/view-on-map" element={<ViewOnMap />} />
          </Routes>
        </Box>
      </Box>
    </Box>
  );
}

// Device view component that handles device-specific routing
const DeviceView = ({
  device,
  selectedDevice,
  deviceLoading,
  handleRefresh,
  data,
  fetchEngineData,
  loadingEngineData,
  chartData,
  chartLoading,
  fetchChartData,
  timeRange,
  setTimeRange,
  startTime,
  endTime,
  selectedRegisters,
  setSelectedRegisters,
}) => {
  // console.log("first test " + deviceLoading);
  const location = useLocation();
  const navigate = useNavigate();

  // Extract current device tab from URL
  const currentPath = location.pathname.split("/").pop();
  const deviceActiveTab =
    currentPath === selectedDevice?.id?.toString()
      ? "engine-data"
      : currentPath;

  const handleDeviceTabChange = (event, newValue) => {
    navigate(`${newValue}`);
  };
  const [deviceVersion, setDeviceVersion] = React.useState(0);

  const refreshDeviceAndDependents = async () => {
    await handleRefresh(); // refetch device from API
    setDeviceVersion((v) => v + 1); // 🔔 notify all dependents
  };

  const renderDeviceContent = () => {
    // console.log("test device", device);
    switch (deviceActiveTab) {
      case "engine-data":
        if (!data) {
          return (
            <Box>
              <Header
                onRefresh={() => fetchEngineData(selectedDevice?.id)}
                deviceName={device ? device.name : "No Device Selected"}
                deviceId={selectedDevice ? selectedDevice?.id : "N/A"}
              />

              <Box
                sx={{
                  mt: 3,
                  p: 4,
                  bgcolor: "#1e293b",
                  borderRadius: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  border: "1px dashed rgba(255,255,255,0.15)",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ color: "#e5e7eb", mb: 1, fontWeight: 500 }}
                >
                  No Contact From This Unit Yet
                </Typography>

                <Typography
                  variant="body"
                  sx={{ color: "#94a3b8", maxWidth: 360 }}
                >
                  This unit has not reported any data yet. Please check the
                  device , or try refreshing.
                </Typography>
              </Box>
            </Box>
          );
        }
        return (
          <div>
            <Header
              onRefresh={() => fetchEngineData(selectedDevice?.id)}
              onPoll={() => fetchEngineData(selectedDevice?.id)}
              loading={loadingEngineData}
              deviceName={device ? device.name : "No Device Selected"}
              deviceId={selectedDevice ? selectedDevice?.id : "N/A"}
            />

            {!device?.isActive && (
              <div className="mb-2 font-bold text-center bg-[#0f1530ff] text-yellow-600 p-3 rounded">
                Unit in Standby
              </div>
            )}

            <div className="flex flex-col xl:flex-row gap-2 mt-1">
              {/* LEFT SECTION */}
              <div className="flex-1 flex flex-col gap-0.5">
                {/* ENGINE + COMPRESSOR */}
                <div className="flex flex-col md:flex-row gap-2">
                  <div className="flex-1">
                    <EngineData data={data} />
                  </div>

                  <div className="flex-1">
                    <CompressorData data={data} />
                  </div>
                </div>

                {/* TELEMETRY */}
                <div className="mt-1">
                  <Telemetry data={data} />
                </div>
              </div>

              {/* RIGHT SECTION — MAP */}
              <div className="bg-slate-800 p-3 flex-1 flex-col flex xl:static xl:flex mt-2 xl:mt-0">
                <h3 className="text-sm font-semibold text-white mb-2">
                  Location
                </h3>

                <div className="flex-1 overflow-hidden xl:h-auto h-64">
                  <DeviceLocation
                    latitude={data?.response?.LAT || 0}
                    longitude={data?.response?.LON || 0}
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "charts":
        return (
          <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
            <TimeRangeSelector
              deviceId={selectedDevice?.id}
              timeRange={timeRange}
              setTimeRange={setTimeRange}
              onRefresh={() =>
                selectedDevice?.id && fetchChartData(selectedDevice.id)
              }
              loading={chartLoading}
              selectedRegisters={selectedRegisters}
              setSelectedRegisters={setSelectedRegisters}
            />
            {chartLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "80vh",
                }}
              >
                <CircularProgress color="#60a5fa" size={70} />
              </Box>
            ) : chartData ? (
              <ChartManager
                timeRange={timeRange}
                chartData={chartData}
                selectedRegisters={selectedRegisters}
              />
            ) : (
              <Box
                sx={{
                  color: "#fff",
                  p: 2,
                  bgcolor: "#1e293b",
                  borderRadius: 2,
                }}
              >
                <Typography>
                  No chart data available. Click Refresh to load data.
                </Typography>
              </Box>
            )}
          </Box>
        );

      case "data-table":
        return <DataTable device={{ ...selectedDevice, name: device?.name }} />;

      case "alarms":
        return <MainAlarm device={{ ...selectedDevice, name: device?.name }} />;

      case "runtime-report":
        return (
          <RuntimeReport device={{ ...selectedDevice, name: device?.name }} />
        );
      case "invalid-table":
        return (
          <InvalidTable device={{ ...selectedDevice, name: device?.name }} />
        );
      case "unit-information":
        return !device && deviceLoading ? (
          // Initial loading overlay (when no device data yet)
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.6)",
              backdropFilter: "blur(4px)",
              borderRadius: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              zIndex: 5,
            }}
          >
            <CircularProgress sx={{ color: "#60a5fa", mb: 2 }} />
            <Typography variant="body2" fontWeight={500}>
              Loading device data...
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
              },
              gridTemplateRows: {
                xs: "auto auto",
                md: "auto 1fr",
              },
              gap: { xs: 2, sm: 2.5, md: 3 },
              height: "auto",
              overflowY: "auto",
              p: 0,
              boxSizing: "border-box",
              position: "relative",
            }}
          >
            {/* Refresh loading overlay */}
            {device && deviceLoading && (
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  backgroundColor: "rgba(0,0,0,0.5)",
                  backdropFilter: "blur(2px)",
                  borderRadius: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  zIndex: 5,
                }}
              >
                <CircularProgress sx={{ color: "#60a5fa", mb: 2 }} />
                <Typography variant="body2" fontWeight={500}>
                  Refreshing device data...
                </Typography>
              </Box>
            )}

            <>
              <Box
                sx={{
                  gridColumn: { xs: "1", sm: "1 / -1" },
                  gridRow: "1",
                  backgroundColor: "#1e293b",
                  borderRadius: 2,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.6)",
                  height: "auto",
                  overflowY: "auto",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  opacity: deviceLoading ? 0.9 : 1,
                  transition: "opacity 0.3s ease",
                }}
              >
                <UnitInformation
                  device={device}
                  handleRefresh={handleRefresh}
                  deviceLoading={deviceLoading}
                />
              </Box>

              {[UnitLocationFields, NotificationGroup, CustomerGroup].map(
                (Component, i) => (
                  <Box
                    key={i}
                    sx={{
                      backgroundColor: "#1e293b",
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
                      boxSizing: "border-box",
                      overflow: "auto",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      minHeight: { xs: "auto", md: "0" },
                      position: "relative",
                    }}
                  >
                    <Component
                      device={device}
                      deviceVersion={deviceVersion}
                      onDeviceUpdated={refreshDeviceAndDependents}
                      deviceLoading={deviceLoading}
                    />
                  </Box>
                ),
              )}
            </>
          </Box>
        );
      case "view-on-map":
        return <ViewOnMap />;

      case "control-page":
        return <ControlPage selectedDevice={selectedDevice} />;

      case "plunger-page":
        return <MainPlungerPage selectedDevice={selectedDevice} />;

      case "historical-sps":
        return <HistoricalSPs device={selectedDevice} />;
      case "fault-setpoints":
        return <FaultSetpoints selectedDevice={{ device: selectedDevice }} />;
      case "fault-snapshot":
        return <FaultSnapshots selectedDevice={{ device: selectedDevice }} />;
      case "fan-clutch":
        return <FanClutch selectedDevice={selectedDevice} />;

      default:
        return <ErrorPage />;
    }
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", sm: "100%", md: "100%" }, // responsive width
        maxWidth: "100%", // never go beyond viewport
        overflowX: "auto", // allow horizontal scroll if content is too wide
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Tabs Header */}
      <Box
        sx={{
          backgroundColor: "#374151",
          borderBottom: "1px solid #4b5563",
          px: { xs: 1, sm: 2, md: 3 },
          py: { xs: 0.5, sm: 0.75, md: 1 },
          width: "100%",
          overflow: "hidden", // ✅ keeps the tabs from overflowing parent
        }}
      >
        <Tabs
          value={deviceActiveTab}
          onChange={handleDeviceTabChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            width: "100%", // ✅ ensures Tabs fit inside Box
            minHeight: { xs: "40px", sm: "45px", md: "48px" },

            "& .MuiTabs-scrollButtons": {
              color: "#9ca3af",
              "&.Mui-disabled": { opacity: 0.3 },
            },

            "& .MuiTab-root": {
              color: "#9ca3af",
              fontSize: { xs: "9px", sm: "12px", md: "14px" },
              padding: { xs: "6px 8px", sm: "8px 12px", md: "12px 16px" },
              minHeight: { xs: "40px", sm: "45px", md: "48px" },
              minWidth: { xs: "auto", sm: "90px", md: "120px" },
              textTransform: "none",
              fontWeight: 500,
              "&.Mui-selected": {
                color: "#ffffffff",
                fontWeight: 600,
              },
            },

            "& .MuiTabs-indicator": {
              backgroundColor: "#ffffffff",
              height: { xs: "2px", sm: "2px", md: "3px" },
            },

            "& .MuiTabs-flexContainer": {
              gap: { xs: 0, sm: 0.5, md: 1 },
            },
          }}
        >
          <Tab label="Field Data" value="engine-data" />
          <Tab label="Charts" value="charts" />
          <Tab label="Data Table" value="data-table" />
          <Tab label="Alarms" value="alarms" />
          <Tab label="Downtime Report" value="runtime-report" />
          <Tab label="Invalid Table" value="invalid-table" />
          <Tab label="Unit Information" value="unit-information" />
          <Tab label="Control" value="control-page" />
          <Tab label="Plunger Page" value="plunger-page" />
          <Tab label="Historical SPs" value="historical-sps" />
          <Tab label="Fault Setpoints" value="fault-setpoints" />
          <Tab label="Fault Snapshots" value="fault-snapshot" />
          <Tab label="Fan Clutch" value="fan-clutch" />
        </Tabs>
      </Box>

      {/* Content Area */}
      <Box
        sx={{
          flex: 1,
          width: "100%", // ✅ keep consistent width
          overflow: "auto", // ✅ allows content inside to scroll if needed
          p: 3,
        }}
      >
        {loadingEngineData &&
        selectedDevice &&
        deviceActiveTab === "engine-data" ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress size={70} />
          </Box>
        ) : (
          renderDeviceContent()
        )}
      </Box>
    </Box>
  );
};
